import { Row, Col, Button, Spinner } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import "./Gallery.css";
import BannerImage from "../../assets/cmc.jpg";
import ViewMoreIcon from "../../assets/right-arrow.svg";
import ReactPlayer from "react-player/youtube";
import axios from "../../network/api";
import { useState, useEffect, useRef } from "react";
import { baseUrl } from "../../network/Constants";

function Gallery() {
  const [loadingGallery, setLoadingGallery] = useState(false);
  const [gallery, setGallery] = useState([]);
  const [visible, setVisible] = useState(6);
  const ViewMoreImages = () => {
    setVisible((prevValue) => prevValue + prevValue);
  };
  const [loadingVideo, setLoadingVideo] = useState(false);
  const [videoGallery, setVideoGallery] = useState([]);
  const [videoVisible, setVideoVisible] = useState(6);
  const moreVideos = () => {
    setVideoVisible((prevValue) => prevValue + prevValue);
  };

  useEffect(() => {
    fetchGallery();
    fetchVideoGallery();
  }, []);

  const fetchGallery = (props) => {
    setLoadingGallery(true);
    axios
      .get(baseUrl + "/app/gallery/")
      .then(async (response) => {
        // setLoading(false);
        setGallery(response.data);
        setLoadingGallery(false);
      })
      .catch((error) => {
        console.log(error);
        setLoadingGallery(false);
        // setLoading(true);
      });
  };

  // viewmore option//

  const fetchVideoGallery = (props) => {
    setLoadingVideo(true);
    axios
      .get(baseUrl + "/app/video/")
      .then(async (response) => {
        // setLoading(false);
        setVideoGallery(response.data);
        setLoadingVideo(false);

        console.log("HuyyaaVideoGallery: " + JSON.stringify(response.data));
      })
      .catch((error) => {
        console.log(error);
        setLoadingVideo(false);

        // setLoading(true);
      });
  };

  return (
    <section className="gallery" id="gallery">
      <Container fluid>
        <div className="gallery-content">
          <Container>
            <div className="section-title">Memories</div>
          </Container>
          {loadingGallery ? (
            <div className="loader">
              <Spinner className="loading-color" />
            </div>
          ) : (
            <Row className="gallery-images">
              {gallery.slice(0, visible).map((item, index) => {
                return (
                  <Col lg={4} className="gallery-image" key={index}>
                    <div className="gallery-overlay">
                      {/* <div className="gallery-overlay-year">{item.year}</div> */}
                    </div>
                    <img
                      src={item.gallery_image}
                      alt={`gallery-${index + 1}`}
                      className="img-fluid"
                    />
                  </Col>
                );
              })}
            </Row>
          )}

          {gallery.length > 6 && (
            <div className="view-more ">
              <Button href="/viewmoreimages" className="view-more-btn">
                View More <img src={ViewMoreIcon} onClick={ViewMoreImages} />
              </Button>
            </div>
          )}
        </div>
      </Container>

      {videoGallery && (
        <Container>
          <div className="section-title pt-5">Videos</div>
          {loadingVideo ? (
            <div className="loader">
              <Spinner className="loading-color" />
            </div>
          ) : (
            <Row className="gallery-images">
              {videoGallery.slice(0, videoVisible).map((item, index) => {
                return (
                  <Col lg={6} className="gallery-video" key={index}>
                    <ReactPlayer
                      width="100%"
                      url={item.link}
                      className="youtube-player pt-3"
                    />
                  </Col>
                );
              })}
            </Row>
          )}
          {videoGallery.length > 4 && (
            <div className="view-more ">
              <Button href="/viewmorevideos" className="view-more-btn">
                View More <img src={ViewMoreIcon} onClick={moreVideos} />
              </Button>
            </div>
          )}
        </Container>
      )}
    </section>
  );
}

export default Gallery;
